require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-6-examples-of-modern-e-commerce-design-that-uses-best-practices.json") })
        }
      }, "path---blog-6-examples-of-modern-e-commerce-design-that-uses-best-practices");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-6-examples-of-modern-e-commerce-design-that-uses-best-practices!./.cache/json/blog-6-examples-of-modern-e-commerce-design-that-uses-best-practices.json
// module id = 408
// module chunks = 231608221292675